import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'

Vue.config.productionTip = false

// --------------------------------------

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyAzCGQrqdnqUWkEd8Xs84aZxVc_0oxtGhs",
    authDomain: "vue-todo-169c9.firebaseapp.com",
    databaseURL: "https://vue-todo-169c9.firebaseio.com",
    projectId: "vue-todo-169c9",
    storageBucket: "vue-todo-169c9.appspot.com",
    messagingSenderId: "949905108120",
    appId: "1:949905108120:web:dddd856546e81a23c7b4ed",
    measurementId: "G-T14ENXZPBL"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
// --------------------------------------


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
